import { BODY_PATH } from '@/assets/icons/logo-geometry';

export const BIRD_SPECIES = ['hummingbird'] as const;

export type BirdSpecies = (typeof BIRD_SPECIES)[number];

export type BirdStroke =
  | { kind: 'fill'; path: string }
  | { kind: 'wing'; x: number; y: number; rotate: number; scale: number };

export type BirdShape = {
  strokes: BirdStroke[];
  eyes: { x: number; y: number; r: number }[];
};

export const WING_BEATS = [0, 8, 15, 8, 0, -7];

export type BirdMotion = { tempo: number; swing: number };

export const BIRD_MOTION: Record<BirdSpecies, BirdMotion> = {
  hummingbird: { tempo: 1.5, swing: 0.8 },
};

const LOGO_BODY_PATH = BODY_PATH.slice(0, BODY_PATH.indexOf('ZM') + 1);

export const BIRD_SHAPES: Record<BirdSpecies, BirdShape> = {
  hummingbird: {
    strokes: [
      { kind: 'fill', path: LOGO_BODY_PATH },
      { kind: 'wing', x: 13, y: 7, rotate: 0, scale: 1 },
    ],
    eyes: [{ x: 17.3, y: 6.55, r: 0.5 }],
  },
};
